













import mixins from 'vue-typed-mixins';
import { SnackBarProp } from '.';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => SnackBarProp,
    },
  },

  data(): {
    visible: boolean;
  } {
    return {
      visible: true,
    };
  },

  watch: {
    visible(visible: boolean) {
      if (!visible) {
        setTimeout(() => {
          (this.$options as any).close();
        }, 500);
      }
    },
  },
});
